import { Box, HStack, StackProps, Icon, IconProps } from "@chakra-ui/react";
import TraitsCanvas, { TraitsCanvasProps } from "components/TraitsCanvas";
import { FaArrowRight } from "react-icons/fa";

type BeforeAfterPreviewProps = {
  oldTraits: number[];
  newTraits: number[];
  arrowSize?: IconProps["w"];
  spacing?: StackProps["spacing"];
} & Omit<TraitsCanvasProps, "traits">;

const BeforeAfterPreview = ({
  oldTraits,
  newTraits,
  spacing = "6",
  arrowSize = "4",
  ...rest
}: BeforeAfterPreviewProps) => (
  <Box position="relative">
    <HStack spacing={spacing}>
      <TraitsCanvas traits={oldTraits} {...rest} />
      <TraitsCanvas traits={newTraits} {...rest} />
    </HStack>

    <Icon
      as={FaArrowRight}
      w={arrowSize}
      h={arrowSize}
      color="secondary.500"
      position="absolute"
      left="50%"
      top="50%"
      transform="translate(-50%, -50%)"
      zIndex={1}
    />
  </Box>
);

export default BeforeAfterPreview;
